// extracted by mini-css-extract-plugin
export var wrapPageElement = "WrapPageElement-module--wrap-page-element--adc44";